import {
  CreateScheduledQueryBody,
  ListScheduledQueriesParams,
  ScheduledQuery,
  scheduledQueries,
  UpdateScheduledQueryBody,
} from '@api';
import { generatePath } from '@helpers';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const listScheduledQueries = (params: ListScheduledQueriesParams = {}) => {
  const path = generatePath({
    basePath: scheduledQueries.list.path,
    params: {
      ...(params.status && { status: params.status }),
      ...(params.page && { page: params.page }),
      ...(params.page_size && { page_size: params.page_size }),
    },
  });

  return wretchRequest(path, { schema: scheduledQueries.list.schema });
};

export const getScheduledQuery = (id: string) =>
  wretchRequest(scheduledQueries.get.path(id), { schema: scheduledQueries.get.schema });

export const listScheduledQueryConversations = (
  id: string,
  params: { page?: number; page_size?: number } = {}
) => {
  // Endpoint #9 lives in conversation service, not conversation-scheduler
  const path = generatePath({
    basePath: scheduledQueries.listConversations.path(id),
    params: {
      ...(params.page && { page: params.page }),
      ...(params.page_size && { page_size: params.page_size }),
    },
  });

  return wretchRequest(path, { schema: scheduledQueries.listConversations.schema });
};

export const createScheduledQuery = (body: CreateScheduledQueryBody): Promise<ScheduledQuery> =>
  wretchRequest(scheduledQueries.create.path, {
    method: 'post',
    body,
    schema: scheduledQueries.create.schema,
  });

export const updateScheduledQuery = (id: string, body: UpdateScheduledQueryBody) =>
  wretchRequest(scheduledQueries.update.path(id), { method: 'put', body });

export const deleteScheduledQuery = (id: string) =>
  wretchRequest(scheduledQueries.delete.path(id), { method: 'delete' });

export const runScheduledQueryNow = (id: string) =>
  wretchRequest(scheduledQueries.runNow.path(id), {
    method: 'post',
    body: {},
    schema: scheduledQueries.runNow.schema,
  });
